import React, { useState, useEffect } from "react";
import axios from "axios";
import Button from "@mui/material/Button";
import LoginDialog from "./LoginDailogue";
import FullPageIframe from "./FullPageIframe";

const PayNowButton = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const [showIframe, setShowIframe] = useState(false);

  useEffect(() => {
    // Check for bearerToken in localStorage when the component mounts
    const token = localStorage.getItem("bearerToken");
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);

  const checkLoginAndCreateOrder = async () => {
    if (!isLoggedIn) {
      setShowLoginPopup(true);
    } else {
      await createOrder();
    }
  };
  const handleLoginSuccess = () => {
    setIsLoggedIn(true);
    setShowLoginPopup(false);
    createOrder(); // Optionally, proceed to create an order after login
  };

  const createOrder = async () => {
    console.log("Creating order");

    try {
      const token = localStorage.getItem("bearerToken");

      const data = {
        planId: "trial_quarter_07",
        os: "android",
        coupon: "",
        exp: "",
        upiDeepLinkFlowRequired: false,
        upiPackageName: "com.google.android.apps.nbu.paisa.user",
        paymentOptions: "4_JPY",
        paymentGateway: "3_JPY",
        paymentOptionsDisplayed: "1_PHP_2_PTM_3_GPY",
        paymentGatewayDisplayed: "4_JPY",
      };

      const config = {
        method: "post",
        url: "https://stageapi.stage.in/v23/juspay-recurring/createAuthorizationTransaction?appId=in.stage.raj_dev&platform=web&customReturnUrl=pay",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        data: data,
      };

      const response = await axios.request(config);
      if (response.status === 200) {
        // Assuming the payment URL is in the response data under the key 'paymentUrl'
        const paymentUrl = response.data.response.payment_links.web;

        if (paymentUrl) {
          // Open the payment URL in a new tab
          //   window.open(paymentUrl);
          setIframeUrl(paymentUrl); // Replace with your link
          setShowIframe(true);
        }
      } else {
        alert("Please use different Mobile Number to login");
      }
      console.log(JSON.stringify(response.data.response.payment_links.web));
    } catch (error) {
      console.error("An error occurred during the order creation:", error);
    }
  };

  const logoutUser = () => {
    try {
      localStorage.removeItem("bearerToken");
      localStorage.removeItem("userId");
      localStorage.removeItem("trialStarted");
      setIsLoggedIn(false);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <Button
        variant="contained"
        style={{
          background: "#2ABC4B",
          width: "70vw",
          maxWidth: "400px",
          borderRadius: "2rem",
        }}
        onClick={checkLoginAndCreateOrder}
      >
        ट्रायल शुरू करें >
      </Button>
      {isLoggedIn && (
        <Button variant="contained" onClick={logoutUser}>
          Logout
        </Button>
      )}
      <LoginDialog
        open={showLoginPopup}
        onClose={() => setShowLoginPopup(false)}
        onLoginSuccess={handleLoginSuccess}
      />
      {showIframe && (
        <FullPageIframe
          onClose={() => {
            console.log("close1");
            setShowIframe(false);
          }}
          src={iframeUrl}
          allowFullScreen
        />
      )}
    </>
  );
};

export default PayNowButton;
